import { Link } from "react-router-dom";

const FRIEND_LINKS = ["光影社区", "剧集观察", "影视资料馆", "电影周报", "追剧指南"];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-16 md:mt-20">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold">水母影视</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              水母影视汇聚丰富的电影和电视剧资源，提供最新影视资讯和剧情介绍，满足用户免费观看及了解影视内容的需求。覆盖电影、电视剧、综艺等多类影视作品。
            </p>
            <p className="mt-4 text-xs text-background-300/80 leading-relaxed">
              本网站所有影视内容均用于界面与功能演示，不提供真实视频播放服务。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50 uppercase tracking-wide">
              快速导航
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category?type=电影" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category?type=电视剧" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/category?type=综艺" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  综艺频道
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  影视资讯
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50 uppercase tracking-wide">
              友情链接
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {FRIEND_LINKS.map((name) => (
                <li key={name}>
                  <span className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                    {name}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-5 text-xs text-background-300">
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line"></i>
              contact@jellyfish-tv.demo
            </span>
            <Link to="/about" className="flex items-center gap-1.5 hover:text-accent-400 transition-colors cursor-pointer">
              <i className="ri-customer-service-2-line"></i>
              联系我们
            </Link>
          </div>
          <p className="text-xs text-background-300 text-center sm:text-right">
            © 2024 水母影视 · 页面内容与数据均为演示用途
          </p>
        </div>
      </div>
    </footer>
  );
}